export default "__VITE_ASSET__CDZeWCou__"